export default {
  faq: {
    error: 'Error fetching FAQ',
  },
  '403': {
    description:
      "You have completed this conversation. For changes, please contact your provider's office",
  },
  '404': {
    title: 'Page not found',
    description: 'Sorry, we couldn’t find the page you’re looking for.',
  },
  '500': {
    title: 'Server error',
    description: 'Try to contact our technical support team.',
  },

  waitlist: {
    loading: 'Loading appointment details...',
    title: 'An Appointment Slot Is Available',
    description:
      'Great news from {{practice}}! An appointment slot has opened up for you.',
    provider: 'Provider',
    date: 'Date',
    time: 'Time',
    accept: 'Accept Appointment',
    decline: 'Decline',
    submitting: 'Submitting...',
    acceptedTitle: 'Appointment Confirmed',
    acceptedMessage:
      'Your appointment has been confirmed. You will receive a confirmation shortly.',
    declinedTitle: 'Offer Declined',
    declinedMessage:
      'You have declined this appointment offer. You will remain on the waitlist for future openings.',
    expiredTitle: 'Offer Expired',
    expiredMessage:
      'This appointment offer is no longer available. You will be notified when a new slot opens.',
    errorTitle: 'Something Went Wrong',
    errorMessage:
      'We were unable to process your request. Please try again or contact your provider.',
  },

  settings: {
    fontSize: {
      label: 'Font size',
      reset: 'Reset',
    },
    resetChat: {
      label: 'Reset chat',
      confirm: {
        title: 'Are you sure to clear the chat?',
        description: 'This action can not be undone.',
        cancel: 'Cancel',
        okay: 'Clear',
      },
    },
    downloadTranscript: {
      label: 'Download',
    },
    language: {
      label: 'Language',
      'en-US': 'English',
      'es-ES': 'Español',
    },
  },
};
